import { Campaign } from '@shared/types/mylounge';

import { useLeavingSoonVariants } from './useLeavingSoonVariants';
import { useLeavingSoonData } from './useLeavingSoonData';
import { CampaignWithLeavingSoonFlag } from '../types';
import { CAMPAIGN_COUNT_CONSTANTS } from '../../campaignsCarousel/helpers';

interface UseLeavingSoonReturn {
    isLeavingSoonLabel: boolean;
    isLeavingSoonComponent: boolean;
    campaignsForLeavingSoonCarousel: Campaign[] | [];
    leavingSoonCampaignsWithFlag: CampaignWithLeavingSoonFlag[] | Campaign[] | [];
}

export const useLeavingSoon = (): UseLeavingSoonReturn => {
    const { isLeavingSoonLabel, isLeavingSoonComponent } = useLeavingSoonVariants();

    const { leavingSoonCampaigns } = useLeavingSoonData(isLeavingSoonLabel);

    const campaignsForLeavingSoonCarousel = isLeavingSoonComponent
        ? leavingSoonCampaigns.slice(0, CAMPAIGN_COUNT_CONSTANTS.EIGHT_CAMPAIGNS_CAROUSEL)
        : [];

    return {
        isLeavingSoonLabel,
        isLeavingSoonComponent,
        campaignsForLeavingSoonCarousel,
        leavingSoonCampaignsWithFlag: leavingSoonCampaigns,
    };
};
